import updateTree from './updateTree'
import keyBy from 'lodash/keyBy'
import values from  'lodash/values'

export default function messages(state = {}, action) {
  switch (action.type) {

    case 'SET_MESSAGES': {
      return updateTree(state, 'messages.all', prev => keyBy([...values(prev), ...action.messages],'id'))
    }

    case 'SEEN_MESSAGE': {
      return updateTree(state, 'messages.seen', seen => [...seen, action.id])
    }

    default:
      return {
        messages: {
          all: {},
          seen: [],
        },
        ...state
      }
  }
}